export default "/fonts/feather.ttf?aaacbaee6c14b4207d39846c6d971e1f";